export default "__VITE_ASSET__0fe737b8__"